<script setup>
defineProps({
  memberships: { type: Array, default: () => [] },
  compact: { type: Boolean, default: false },
});

function toneClass(tone) {
  return ["gold", "blue", "green"].includes(tone) ? `tone-${tone}` : "tone-neutral";
}
</script>

<template>
  <div v-if="memberships.length" class="member-badges" :class="{ compact }" aria-label="小能熊社区会员身份">
    <span
      v-for="membership in memberships"
      :key="membership.key"
      class="member-badge"
      :class="toneClass(membership.tone)"
    >
      {{ membership.label }}
    </span>
  </div>
</template>

